export default __webpack_public_path__ + "static/media/halftone_leonie.f932b195.png";